import { render, staticRenderFns } from "./anxious.vue?vue&type=template&id=5fe7b9af&lang=pug&"
import script from "./anxious.vue?vue&type=script&lang=js&"
export * from "./anxious.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports